/* ALCHEMY founders slider: native scroll-snap, arrows + counter. No autoplay. */
(() => {
  if (customElements.get('founders-slider')) return;
  class FoundersSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.count = this.querySelector('[data-count]');
      this.slides = [...this.track.children];
      const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const go = (dir) => {
        const i = Math.min(this.slides.length - 1, Math.max(0, this.index() + dir));
        this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: calm ? 'auto' : 'smooth' });
      };
      const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => go(-1));
      if (next) next.addEventListener('click', () => go(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(1); if (e.key === 'ArrowLeft') go(-1); });
      this.update();
    }
    index() { return Math.round(this.track.scrollLeft / this.track.clientWidth); }
    update() {
      const pad = (n) => String(n).padStart(2, '0');
      if (this.count) this.count.textContent = `${pad(this.index() + 1)} / ${pad(this.slides.length)}`;
    }
  }
  customElements.define('founders-slider', FoundersSlider);
})();

/* ALCHEMY founders photos: slow crossfade between the photos on a slide. Paused for reduced motion, hidden tabs and off-screen. */
(() => {
  if (customElements.get('founders-fade')) return;
  class FoundersFade extends HTMLElement {
    connectedCallback() {
      this.frames = [...this.querySelectorAll('.ah-fnd__frame')];
      if (this.frames.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.current = Math.max(0, this.frames.findIndex((f) => f.classList.contains('is-active')));
      this.visible = true;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (this.visible && !this.warmed) { this.warmed = true; this.frames.forEach((f) => { f.loading = 'eager'; }); }
        });
        this.io.observe(this);
      }
      this.timer = setInterval(() => this.next(), 3800);
    }
    next() {
      if (!this.visible || document.hidden) return;
      const ready = (f) => f.complete && f.naturalWidth > 0;
      let n = this.current;
      for (let i = 0; i < this.frames.length; i++) {
        n = (n + 1) % this.frames.length;
        if (ready(this.frames[n])) break;
      }
      if (n === this.current || !ready(this.frames[n])) return;
      this.frames[this.current].classList.remove('is-active');
      this.current = n;
      this.frames[this.current].classList.add('is-active');
    }
    disconnectedCallback() { clearInterval(this.timer); if (this.io) this.io.disconnect(); }
  }
  customElements.define('founders-fade', FoundersFade);
})();
